/**
 * Lightweight in-app navigation guard for Multi-Territory screens.
 *
 * The app uses a declarative <HashRouter>, so react-router's `useBlocker`
 * (data-router only) is not available. Screens with unsaved edits register a
 * guard here; navigation triggers that do not go through an <a href> (e.g. the
 * MT sidebar buttons, country switcher) call `runWithMTNavigationGuard`.
 *
 * A guard receives the navigation `proceed` callback and returns `true` when
 * it has taken over (e.g. opened a confirmation dialog and will call `proceed`
 * itself on confirm), or `false` to let navigation continue immediately.
 */
export type MTNavigationGuard = (proceed: () => void) => boolean

let activeGuard: MTNavigationGuard | null = null

/** Registers the active guard. Returns an unregister function. */
export function setMTNavigationGuard(guard: MTNavigationGuard): () => void {
  activeGuard = guard
  return () => {
    if (activeGuard === guard) activeGuard = null
  }
}

/** Runs `action` unless the active guard intercepts it. */
export function runWithMTNavigationGuard(action: () => void): void {
  if (activeGuard && activeGuard(action)) return
  action()
}
